module.exports = __webpack_public_path__ + "img/sample_text.34ef6d8b.jpeg";